import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BasketStore } from '@features/basket';
import { SiteStore } from '@core/site/site.store';

@Component({
  selector: 'app-floating-basket-button',
  imports: [MatButtonModule, MatIconModule],
  template: `
    <span class="fab__announcement" aria-live="polite" aria-atomic="true">
      {{ expanded() ? 'Tilføjet til kurv' : '' }}
    </span>
    @if ((basket.itemsCount() > 0 || contained()) && !site.isCheckoutPage()) {
      <div class="fab-wrap" [class.fab-wrap--expanded]="expanded()" [class.fab-wrap--contained]="contained()">
        <div class="fab__label-clip">
          <span class="fab__label" aria-hidden="true">Tilføjet til kurv</span>
        </div>
        <button mat-fab class="fab__btn" (click)="openBasket()" aria-label="Åbn kurv">
          <mat-icon aria-hidden="true">shopping_cart</mat-icon>
          <span class="fab__badge">{{ basket.itemsCount() }}</span>
        </button>
      </div>
    }
  `,
  styleUrl: './floating-basket-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingBasketButtonComponent {
  readonly contained = input(false);
  protected readonly basket = inject(BasketStore);
  protected readonly site = inject(SiteStore);
  protected readonly expanded = signal(false);

  protected openBasket(): void {
    this.site.openRightDrawer();
  }

  constructor() {
    const initialAddCount = this.basket.addCount();
    let collapseTimer: ReturnType<typeof setTimeout> | null = null;

    effect(() => {
      if (this.basket.addCount() === initialAddCount) return;
      if (collapseTimer) clearTimeout(collapseTimer);
      this.expanded.set(true);
      collapseTimer = setTimeout(() => this.expanded.set(false), 2000);
    });

    inject(DestroyRef).onDestroy(() => {
      if (collapseTimer) clearTimeout(collapseTimer);
    });
  }
}
